import 'moment/locale/es'
import moment from 'moment-timezone'

export const mdy = date => moment(date).utc(true).format('DD/MM/YYYY')
export const mdyhm = date => moment(date).format('DD/MM/YYYY, hh:mm A')
export const ymdHTML = date => moment(date).utc(true).format('YYYY-MM-DD')

export const zeroUTC = date =>
  moment(date).utc().set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
